<template>
    <div class="row">
        <div class="col-sm-12 overflow-auto">
            <b-table striped hover bordered :fields="fields" :items="items" responsive="sm">
                <template #cell(index)="data">
                    {{ data.index + startPage }}
                </template>
                <template #cell(title)="data">
                    <a class="text-primary fw-500 link" @click="showEditSubCategory(data.item)">{{data.item.title}}</a>
                </template>
                <template #cell(category)="data">
                    {{getCategoryText(data.item.category)}}
                </template>
                <template #cell(isEnable)="data">
                    <span class="badge" :class="data.item.isEnable == 1 ? 'badge-primary' : 'badge-secondary'">{{data.item.isEnable == 1 ? $t('table.value.enable') : $t('table.value.disable')}}</span>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import {getCategoryText} from './../../../assets/js/dashboard/dashboard'
export default {
    name: 'salonMenuSubCategory',
    props: {
        category: Array,
        items: Array,
        startPage: Number
    },
    data(){
        return{
            categoryList: []
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "folderID", label: this.$i18n.t('table.header.id', {'item': this.$i18n.t('label.subcategory')}) , thClass: 'thead-themed align-middle', sortable: true},
                { key: "title", label:  this.$i18n.t('table.header.title') , thClass: 'thead-themed align-middle', sortable: true},
                { key: "category", label:  this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle' },
                { key: "isEnable", label:  this.$i18n.t('table.header.enable'), thClass: 'thead-themed align-middle' },
            ]
        },
    },
    methods:{
        showEditSubCategory(item){
            this.$emit('showEditSubCategory', item)
        },
        getCategoryText(id){
            return getCategoryText(id, this.categoryList)
        },
    },
    mounted(){
        let $vm = this
        for(var i=1; i<$vm.category.length; i++){
            $vm.categoryList.push({
                id: $vm.category[i].id,
                text: $vm.category[i].text
            })
        }
    },
}
</script>